import React, { useEffect, useState } from 'react';
import { getTerminalBanners } from '../services/shipturtleApi';

// Banner height = 3× the header logo height (70px)
const BANNER_HEIGHT = 210;

/**
 * Displays both terminal banners side by side.
 * Read-only — banners are managed exclusively through the Django admin.
 */
function TerminalBannerManager() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    getTerminalBanners()
      .then(setBanners)
      .catch(() => {});
  }, []);

  const getSlot = (slot) => banners.find((b) => b.slot === slot) || null;

  const banner1 = getSlot(1);
  const banner2 = getSlot(2);

  if (!banner1 && !banner2) return null;

  return (
    <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
      {[banner1, banner2].map((banner, i) => {
        if (!banner) return null;
        return (
          <div
            key={banner.slot}
            style={{
              flex: 1,
              height: BANNER_HEIGHT,
              borderRadius: 10,
              overflow: 'hidden',
              background: '#e8f5f5',
            }}
          >
            <img
              src={banner.image_url}
              alt={`Suspire Terminal Banner ${i + 1}`}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>
        );
      })}
    </div>
  );
}

export default TerminalBannerManager;
